import { render, staticRenderFns } from "./AggregatedWarningsDialog.vue?vue&type=template&id=9508be58&"
import script from "./AggregatedWarningsDialog.vue?vue&type=script&lang=js&"
export * from "./AggregatedWarningsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports